<template>
	<gc-dialog
		:title="hasTenantAdmin ? '修改密码' : '激活管理员账号'"
		:show.sync="visible"
		@ok="handleOk"
		@cancel="$emit('close-modal')"
		@close="$emit('close-modal')"
	>
		<el-form ref="form" :model="form" :rules="formRules" label-position="top">
			<el-form-item label="登录账号">
				<el-input :value="loginAccount" disabled></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="newPwd">
				<el-input
					v-model="form.newPwd"
					placeholder="请输入密码"
					type="password"
					show-password
					autocomplate="new-password"
				></el-input>
			</el-form-item>
		</el-form>
	</gc-dialog>
</template>

<script>
import { ruleRequired, ruleComplexPassValidate } from '@/utils/rules'
import { apiResetTenantAdminPassword, apiActivateTenantAdmin } from '@/apis/tenant.api'
import { encrypt, generatePassword } from '@/utils'

export default {
	props: {
		tenantId: String,
		loginAccount: String,
		hasTenantAdmin: Boolean,
	},
	data() {
		return {
			visible: true,
			form: {
				newPwd: generatePassword(),
			},
			formRules: {
				newPwd: [ruleRequired('请输入密码'), ruleComplexPassValidate()],
			},
		}
	},
	methods: {
		handleOk() {
			this.$refs.form.validate(async valid => {
				if (valid) {
					const API = this.hasTenantAdmin ? apiResetTenantAdminPassword : apiActivateTenantAdmin
					await API({
						tenantId: this.tenantId,
						newPwd: encrypt(this.form.newPwd),
						loginAccount: this.loginAccount,
					})
					this.$message.success(this.hasTenantAdmin ? '修改密码成功' : '激活账号成功')
					this.$emit('close-modal', !this.hasTenantAdmin)
				}
			})
		},
	},
}
</script>
<style lang="scss" scoped>
::v-deep {
	.el-input__suffix-inner .iconfont {
		font-size: 22px;
		cursor: pointer;
	}
}
.warning-tip {
	padding: 0 17px;
	margin: 0 auto 8px;
	width: 432px;
	height: 30px;
	background: #ffebe9;
	border-radius: 16px;
	font-size: 10px;
	color: #ec6b60;
	line-height: 30px;
	box-sizing: border-box;
	span {
		font-size: 16px !important;
	}
}
</style>
